import React, { useState } from "react";
import "../../assets/styles/table.css";
import { FiEye, FiEdit2, FiTrash2 } from "react-icons/fi";
import { IOrder } from "../../types";

const ordersData: IOrder[] = [
  {
    id: 1,
    orderNumber: "ORD-001",
    customer: "Alice Smith",
    date: "2024-06-01",
    status: "Shipped",
    total: "$120.00",
  },
  {
    id: 2,
    orderNumber: "ORD-002",
    customer: "Bob Jones",
    date: "2024-06-02",
    status: "Pending",
    total: "$80.00",
  },
  {
    id: 3,
    orderNumber: "ORD-003",
    customer: "Charlie Brown",
    date: "2024-06-03",
    status: "Delivered",
    total: "$200.00",
  },
];

const orderColumns = [
  { key: "orderNumber", label: "Order #" },
  { key: "customer", label: "Customer" },
  { key: "date", label: "Date" },
  { key: "status", label: "Status" },
  { key: "total", label: "Total" },
];

const PAGE_SIZE = 10;
const TableOrder: React.FC<{
  pageNumber: number;
  setTotalCount: (count: number) => void;
  searchValue?: string;
}> = ({ pageNumber, setTotalCount, searchValue = "" }) => {
  React.useEffect(() => {
    setTotalCount(ordersData.length);
  }, [setTotalCount]);
  // Filter logic

  return (
    <div className="tableWrapper">
      <table className="table">
        <thead>
          <tr>
            {orderColumns.map((col) => (
              <th key={col.key}>{col.label}</th>
            ))}
            <th></th>
          </tr>
        </thead>
      </table>
      <div className="tableBodyWrapper">
        <table className="table">
          <tbody>
            {ordersData.map((row: IOrder) => (
              <tr key={row.id}>
                {orderColumns.map((col) => (
                  <td key={col.key}>{row[col.key as keyof IOrder]}</td>
                ))}
                <td className="actionCell">
                  <button
                    className="actionButton"
                    onClick={() => alert(`View ${row.id}`)}
                    title="View"
                  >
                    <FiEye />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TableOrder;
